import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Paginator, List } from "extranet-component-library";
import alert from '../assets/img/alert.svg';
import _ from "lodash";
import { parseDate } from "../utils/parsers";

interface DistributionType {
  idDistributionType: string;
  name: string;
  passive: boolean;
}

interface Alert {
  idAlert: number;
  text: string;
  creationDate: string;
  creationAuthor: string;
  expirationDate: string;
  expirationAuthor: string;
  entityId: number;
  picture: string;
  distributionTypes: DistributionType[];
  alertLines: number[];
  alertStops: string;
}

interface AlertsProps {
  alerts: Alert[];
}

const Alerts = ({ ...props }: AlertsProps) => {
  const { t } = useTranslation();
  const [propertiesAlerts, setPropertiesAlerts] = useState({
    first: 0,
    page: 0,
    items: [] as Alert[][],
    isOpen: -1
  });
  const rows = 5;

  useEffect(() => {
    setPropertiesAlerts({
      ...propertiesAlerts,
      items: _.chunk(props.alerts, rows),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.alerts && props.alerts.length]);

  const onPageChange = (info: any) => {
    setPropertiesAlerts({
      ...propertiesAlerts,
      first: info.first,
      page: info.page,
    });
  };

  const seeDetail = (index: number) => {
    setPropertiesAlerts({
      ...propertiesAlerts,
      isOpen: index,
    });
  };

  let data: Alert[] = propertiesAlerts.items[propertiesAlerts.page];
  if (data) {
    data = data.map((notice: Alert) => {
      const copy = { ...notice };
      copy.creationDate = parseDate(copy.creationDate, true)
      return copy;
    })
  }

  return (
    <div className="favs-table">
      <div className="title">{t("reminder")}</div>
      {props.alerts && props.alerts.length ? (
        <div data-testid="resolved">
          <List
            icon={alert}
            items={data}
            open={propertiesAlerts.isOpen}
            translate={t}
            onClickItem={(index: number) => seeDetail(index)}
          />
          <Paginator
            data-testid="paginator"
            total={props.alerts.length}
            first={propertiesAlerts.first}
            rows={rows}
            onPageChange={(info: any) => onPageChange(info)}
          />
        </div>
      ) : (
        <div data-testid="no-alerts" className="no-items">
          {t("no_items")}
        </div>
      )}
    </div>
  );
};

export default Alerts;
